import { Button } from '@jouzen/ecom-components/v3/Button';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'next-intl';
import { useMemo, useRef } from 'react';

import flattenJobs from '@/app/[locale]/careers/_components/CareersGreenhouseJobBoard/utils/flattenJobs';
import { getGreenhouseOfficeTreeWithQueryKey } from '@/app/[locale]/careers/_queries/GetGreenhouseOfficeTree';
import Section from '@/app/components/LegacyLandingPage/components/Section';

import { JOB_BOARD_NAME } from './consts';
import JobBoardContents from './JobBoardContents';

const CareersGreenhouseJobBoard = () => {
  const {
    data: officeTreeData,
    isLoading,
    isError,
  } = useQuery(getGreenhouseOfficeTreeWithQueryKey(JOB_BOARD_NAME));
  const topOfComponentRef = useRef<HTMLDivElement>(null);
  const t = useTranslations();

  const jobs = useMemo(
    () => flattenJobs(officeTreeData?.offices ?? []),
    [officeTreeData],
  );

  const onSelectDepartment = () => {
    topOfComponentRef.current?.scrollIntoView();
  };

  return (
    <Section data-cy="careers-job-board">
      <div id="open-positions" ref={topOfComponentRef} />
      <LayoutGrid>
        <Typography
          variant="h1"
          weight="light"
          className="col-main w-3/4 md:w-full"
        >
          {t('ready_when_you_are')}
        </Typography>
      </LayoutGrid>

      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Button
            target="_blank"
            className="my-8"
            href="https://job-boards.greenhouse.io/oura"
            rel="nofollow"
            variant="secondary-dark"
          >
            {t('see_all_positions')}
          </Button>
        </GridItem>
      </LayoutGrid>

      <LayoutGrid data-cy="careers-greenhouse-job-board">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <JobBoardContents
            onSelectDepartment={onSelectDepartment}
            isLoading={isLoading}
            hasError={isError}
            jobs={jobs}
          />
        </GridItem>
      </LayoutGrid>
    </Section>
  );
};

export default CareersGreenhouseJobBoard;
